module.exports = __webpack_public_path__ + "img/img11.7a27a212.svg";